import { style as globalStyle } from '@/styles/globals';
import RoomIcon from '@mui/icons-material/Room';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@mui/styled-engine';
import Box from '@mui/system/Box';
import { useState } from 'react';
import Select, { components, ControlProps } from 'react-select';
import { clearPoints } from '../../../slices/area/slices/searchFlightFormSlice';
import { useAppDispatch, useAppSelector } from '../../../utils/hook';
import SearchDialog from '../SearchDialog';
import { ISearchFromInputParams } from '../SearchDialog/index.d';
import { pr } from '@/utils/pxToRem';
import { isEmpty } from 'lodash';

const SearchFormInput = ({
  type,
  isDesktop,
}: ISearchFromInputParams) => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const { startPointHome, toPointHome } = useAppSelector((store) => store.searchFlightForm);

  const areaPoint = type === 'from' ? startPointHome : toPointHome;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = () => {
    setOpen(false);
  };

  let inputValue = null;
  if (!isEmpty(areaPoint) && areaPoint) {
    inputValue = {
      label: <></>,
      value: '',
    };
    if (areaPoint?.airports?.length > 1) {
      inputValue.label = (
        <div style={{ display: 'flex' }}>
          <Typography variant="body1">{areaPoint.location}</Typography>
          <Typography
            sx={{
              ml: 0.5,
              mt: '1px',
            }}
            variant="caption"
          >
            {' '}
            -
            {' '}
            {areaPoint.airports.length}
            {' '}
            sân bay
          </Typography>
        </div>
      );
    } else {
      inputValue.label = (
        <div style={{ display: 'flex' }}>
          <StyledTypography variant="body1">{areaPoint.location}</StyledTypography>
          <StyledTypography
            sx={{
              ml: 0.5,
            }}
            variant="caption"
          >
            {' '}
            -
            {' '}
            {areaPoint.airports?.[0]?.nameVn}
          </StyledTypography>
        </div>
      );
    }
  }

  const Control = ({ children, ...props }: ControlProps<any, false>) => {
    const style = { cursor: 'pointer' };

    return (
      <div style={{ width: '100%' }}>
        <components.Control {...props}>
          <span style={style}>
            <div style={{
              margin: '6px -1px 0px 13px',
              color: '#4F4F4F',
            }}
            >
              {type === 'from' ? <GpsFixedIcon /> : <RoomIcon />}
            </div>
          </span>
          {children}
        </components.Control>
      </div>
    );
  };

  return (
    <div>
      <StyledBox isDesktop={isDesktop}>
        <Select
          instanceId={type.toString()}
          closeMenuOnSelect={false}
          components={{
            Control,
            IndicatorSeparator,
            DropdownIndicator,
          }}
          // isMulti
          styles={{
            container: (base) => ({
              ...base,
              width: '100%',
              border: 'none',
              overflow: 'hidden',
              backgroundColor: 'inherit',
              borderRadius: pr`6px`,
            }),
            valueContainer: (base) => ({
              ...base,
              // top: '0.4em',
              flexWrap: 'nowrap',
              overflow: 'unset',
            }),
            placeholder: (base) => ({
              ...base,
              color: 'rgba(0, 0, 0, 0.87)',
              fontSize: '0.875rem',
            }),
            control: (base) => ({
              ...base,
              flexWrap: 'nowrap',
              overflow: 'auto',
              height: 46,
              background: globalStyle.color.black7,
              border: 'none',
              boxShadow: 'none',
              color: globalStyle.color.black1,
            }),
          }}
          placeholder={type === 'from' ? 'Nhập nơi đi' : 'Nhập nơi đến'}
          value={inputValue}
          onChange={(newValue, actionMeta) => {
            if (actionMeta.action === 'remove-value') {
              // dispatch(
              //   removePoints({ data: actionMeta.removedValue, type: 'from' }),
              // );
              setOpen(true);
            }
            if (actionMeta.action === 'clear') {
              dispatch(clearPoints({ type: 'from' }));
              setOpen(true);
            }
          }}
          onMenuOpen={() => {
            setOpen(true);
          }}
          menuIsOpen={false}
          options={[]}
        />
      </StyledBox>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="body"
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <SearchDialog
          type={type}
          setClose={() => {
            setOpen(false);
          }}
        />
      </Dialog>
    </div>
  );
};

const StyledBox = styled(Box)((props: any) => ({
  background: '#21212114',
  borderRadius: props?.isDesktop ? pr`6px` : pr`16px`,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'flex-end',
  marginBottom: pr`8px`,
}));

const StyledTypography = styled(Typography)({
  // fontWeight: 'bold',
  fontSize: '1rem',
  lineHeight: 'unset',
});

const IndicatorSeparator = () => <></>;

const DropdownIndicator = () => <></>;

export default SearchFormInput;
